import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";

export const Container = styled(Box)(
  ({ theme }) => `
  margin-top: ${theme.spacing(2)};
  margin-bottom: ${theme.spacing(2)};
  display: flex;
  justify-content: space-between;
  align-items: center;
`,
);
